module.exports = __webpack_public_path__ + "img/checkboxes.c54631c9.svg";